import { Component } from '@angular/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { ToastService } from '../toast.service';

@Component({
  selector: 'app-my-tracker',
  templateUrl: './my-tracker.component.html',
  styleUrls: ['./my-tracker.component.scss'],
})
export class MyTrackerComponent  {
  loader;
  constructor(public service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public toast: ToastService,
    public auth:AuthService) { }

    ionViewWillEnter(){
      sessionStorage.setItem('vendorApp','true');
    }

}
